import { useEffect, useRef, useState } from "react";

/**
 * Counts deep links that arrive while the page is already mounted. The view
 * store reads URL filters once on mount, so a filters-only navigation (for
 * example "View skipped" on a toast shown over Transactions) needs a key
 * change to be consumed. The initial deep link doesn't count, since the mount
 * itself consumes it.
 */
export function useDeepLinkGeneration(options: {
    hasDeepLink: boolean;
    onNewDeepLink?: () => void;
}): number {
    const { hasDeepLink, onNewDeepLink } = options;
    const previousHasDeepLinkRef = useRef(hasDeepLink);
    const onNewDeepLinkRef = useRef(onNewDeepLink);
    onNewDeepLinkRef.current = onNewDeepLink;
    const [generation, setGeneration] = useState(0);

    useEffect(() => {
        const isNewDeepLink = hasDeepLink && !previousHasDeepLinkRef.current;
        previousHasDeepLinkRef.current = hasDeepLink;
        if (isNewDeepLink) {
            setGeneration((current) => current + 1);
            onNewDeepLinkRef.current?.();
        }
    }, [hasDeepLink]);

    return generation;
}
